import { minimumLengthTest } from 'src/front/common/utils/validationSchemas';
import { MINIMUM_DATE_CONTROL } from 'src/front/constant';
import * as Yup from 'yup';

const REQUIRED_MSG = 'general_requiredField_errorMessage';
const MIN_CHAR_MSG = 'general_minCharacter_errorMessage';
const MIN_YEAR_MSG = 'cardEntry_minimumYear_errorMessage';
const FUTURE_DATE_MSG = 'general_FutureDateCanNotSelected_errorMessage';
const PAST_DATE_MSG = 'general_PastDateCanNotSelected_errorMessage';

const DefaultSchema: Yup.ObjectSchema = Yup.object().shape({
  identityType: Yup.object().nullable().required('general_requiredField_errorMessage'),
});
export const serialCode = (minLen: number): Yup.StringSchema =>
  Yup.string().required(REQUIRED_MSG).test(minimumLengthTest(minLen, MIN_CHAR_MSG));

export const serialNumber = (minLen: number): Yup.StringSchema =>
  Yup.string().required(REQUIRED_MSG).test(minimumLengthTest(minLen, MIN_CHAR_MSG));

export const issueDate = (todayMaxControlKey = '$todayMaxControl'): Yup.DateSchema<Date | null> =>
  Yup.date()
    .nullable()
    .when([todayMaxControlKey], (todayMax: Date, schema: Yup.DateSchema) =>
      schema
        .min(MINIMUM_DATE_CONTROL, MIN_YEAR_MSG)
        .max(todayMax, FUTURE_DATE_MSG)
        .required(REQUIRED_MSG)
    );

export const expireDate = (
  required: boolean,
  todayMinControlKey = '$todayMinControl'
): Yup.DateSchema<Date | null> =>
  Yup.date()
    .nullable()
    .when([todayMinControlKey], (todayMin: Date, schema: Yup.DateSchema) => {
      const s = schema.min(todayMin, PAST_DATE_MSG);
      return required ? s.required(REQUIRED_MSG) : s.notRequired();
    });

const issueCountry = (): Yup.ObjectSchema<object | null> =>
  Yup.object().nullable().required(REQUIRED_MSG);
const issuedBy = (): Yup.StringSchema => Yup.string().required(REQUIRED_MSG);
const unitCode = (minLen: number): Yup.StringSchema =>
  Yup.string().required(REQUIRED_MSG).test(minimumLengthTest(minLen, MIN_CHAR_MSG));

type SchemaChunk = Record<string, Yup.Schema<any>>;

function composeSchema(...chunks: SchemaChunk[]): Yup.ObjectSchema<any> {
  const baseShape = {
    ...DefaultSchema.fields,
  };
  const extraShape = Object.assign({}, ...chunks);

  return Yup.object().shape({
    ...baseShape,
    ...extraShape,
  });
}
export const withSerialCode = (len: number): SchemaChunk => ({
  identityDocumentSerialCode: serialCode(len),
});

export const withSerialNumber = (len: number): SchemaChunk => ({
  identityDocumentSerialNumber: serialNumber(len),
});

export const withIssueDate = (): SchemaChunk => ({
  issueDate: issueDate(),
});

export const withExpireDate = (required: boolean): SchemaChunk => ({
  expireDate: expireDate(required),
});

export const withIssueCountry = (): SchemaChunk => ({
  issueCountry: issueCountry(),
});
export const withIssuedBy = (): SchemaChunk => ({
  issuedBy: issuedBy(),
});
export const withUnitCode = (len: number): SchemaChunk => ({
  unitCode: unitCode(len),
});

export const PassportRfSchema = composeSchema(
  withSerialCode(4),
  withSerialNumber(6),
  withIssueDate(),
  withIssuedBy(),
  withIssueCountry(),
  withUnitCode(6)
);

export const VisaSchema = composeSchema(
  withSerialCode(2),
  withSerialNumber(7),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const MigrationCardSchema = composeSchema(
  withSerialCode(4),
  withSerialNumber(0),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const ForeignPassportSchema = composeSchema(
  withSerialCode(2),
  withSerialNumber(7),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const TemporaryResidencePermitSchema = composeSchema(
  withSerialCode(2),
  withSerialNumber(7),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const SeamanPassportSchema = composeSchema(
  withSerialCode(2),
  withSerialNumber(6),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const PassportForeignCitizenSchema = composeSchema(
  withSerialNumber(0),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const DriverLicenseSchema = composeSchema(
  withSerialCode(4),
  withSerialNumber(5),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export const InnSchema = composeSchema(withSerialNumber(12), withIssueCountry());

export const InsuranceCertificateSchema = composeSchema(withSerialNumber(14), withIssueCountry());

export const ResidentPermitSchema = composeSchema(
  withSerialCode(2),
  withSerialNumber(7),
  withIssueDate(),
  withExpireDate(true),
  withIssuedBy(),
  withIssueCountry()
);

export default DefaultSchema;

// const BaseSchema = DefaultSchema.shape({
//   issueCountry: Yup.object().nullable().required('general_requiredField_errorMessage'),
// });
//
// export const PassportRfSchema = DefaultSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(4, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(6, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
//   unitCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(6, 'general_minCharacter_errorMessage')),
// });
//
// export const DriverLicenseSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(4, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(6, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
//
// export const InsuranceCertificateSchema = BaseSchema.shape({
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(14, 'general_minCharacter_errorMessage')),
// });
// export const InnSchema = BaseSchema.shape({
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(12, 'general_minCharacter_errorMessage')),
// });
// export const ResidentPermitSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(2, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(7, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
// export const VisaSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(2, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(7, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
// export const MigrationCardSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(4, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(0, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
// export const ForeignPassportSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(2, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(7, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
// export const TemporaryResidencePermitSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(2, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(7, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
// export const SeamanPassportSchema = BaseSchema.shape({
//   identityDocumentSerialCode: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(2, 'general_minCharacter_errorMessage')),
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(6, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
// export const PassportForeignCitizenSchema = BaseSchema.shape({
//   identityDocumentSerialNumber: Yup.string()
//     .required('general_requiredField_errorMessage')
//     .test(minimumLengthTest(0, 'general_minCharacter_errorMessage')),
//   issueDate: Yup.date()
//     .nullable()
//     .when(['$todayMaxControl'], (todayMaxControl: Date, schema: Yup.DateSchema) =>
//       schema
//         .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
//         .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
//         .required('general_requiredField_errorMessage')
//     ),
//   expireDate: Yup.date()
//     .nullable()
//     .when(['$todayMinControl'], (todayMinControl: Date, schema: Yup.DateSchema) =>
//       expireDateValidation(true, todayMinControl, schema)
//     ),
//   issuedBy: Yup.string().required('general_requiredField_errorMessage'),
// });
//
// const expireDateValidation = (
//   required: boolean,
//   todayMinControl: Date,
//   schema: Yup.DateSchema
// ): any => {
//   schema.min(todayMinControl, 'general_PastDateCanNotSelected_errorMessage');
//   if (required) {
//     return schema.required('general_requiredField_errorMessage');
//   }
//   return schema.notRequired();
// };
//
// export default DefaultSchema;
